import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../components/login.vue'
import dashboard from '../components/dashboard.vue'
import store from '../store'; 
// import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    beforeEnter: async (to, from, next) => {
      // Esperamos que getSkin termine antes de continuar
      if (!store.state.skins || Object.keys(store.state.skins).length === 0) {
        await store.dispatch("getSkin"); // Despachamos getSkin si aún no está cargado
      }
      next(); // Permite continuar con la navegación
    }
  },
]

const router = new VueRouter({
  routes,
})
export default router
